module.exports = __webpack_public_path__ + "img/logo-active-progress.42646ca4.png";